import styled from "styled-components/macro";

import store from "@/store";

import { useVastAd } from "./use-vast-ad";

const AdVideo = styled.video`
  width: 99%;
  height: 95%;
  object-fit: contain;
  cursor: pointer;
`;

type AdProps = {
  src: string;
};

function dismissAd() {
  store.game.ad = null;
}

export function Ad({ src }: AdProps) {
  const vast = useVastAd(src, dismissAd);

  if (!vast) {
    return null;
  }

  return (
    <AdVideo
      key={vast.ad.mediaUrl}
      src={vast.ad.mediaUrl}
      title="Advertisement"
      autoPlay
      muted
      loop
      playsInline
      onPlay={vast.handlers.onPlay}
      onClick={vast.handlers.onClick}
      onError={vast.handlers.onError}
    />
  );
}
